// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"602e8c7d","678":"6577b2aa","787":"fa00ca52","826":"cbca8cae","867":"9d1d0594","982":"fac069f0"}[chunkId] + ".chunk.js";
};